import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ErrorBoundary } from "react-error-boundary";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import * as Sentry from "@sentry/react";

import { MainErrorFallback } from "@/components/errors/main";
import { Spinner } from "@/components/ui/spinner";
import { Suspense, useState } from "react";
import { queryConfig } from "@/lib/react-query";
import { validateToken } from "@/lib/auth/token-validator";
import { AssetTokenSync } from "@/components/auth/asset-token-sync";
// import { Notifications } from '@/components/ui/notifications';
// import { AuthLoader } from '@/lib/auth';

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  validateToken();

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: queryConfig,
      })
  );

  return (
    <Suspense
      fallback={
        <div className="flex h-screen w-screen items-center justify-center">
          <Spinner size="xl" />
        </div>
      }
    >
      <ErrorBoundary
        FallbackComponent={MainErrorFallback}
        onError={(error, info) => {
          Sentry.captureException(error, {
            extra: { componentStack: info.componentStack },
          });
        }}
      >
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            {import.meta.env.DEV && <ReactQueryDevtools />}
            <Toaster closeButton />
            <AssetTokenSync />
            {/* <Notifications />
            <AuthLoader
              renderLoading={() => (
                <div className="flex h-screen w-screen items-center justify-center">
                  <Spinner size="xl" />
                </div>
              )}
            > */}
            {children}
            {/* </AuthLoader> */}
          </QueryClientProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </Suspense>
  );
};
